import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
import Main from './views/Main.vue'

// ユーザー
import User from './views/users/List.vue';

// コンテンツ
import Content from './views/contents/List.vue';
import Series from './views/contents/Series.vue';
import Category from './views/contents/Category.vue';
import Image from './views/contents/Image.vue';
import Movie from './views/contents/Movie.vue';
import View from './views/contents/View.vue';
import Player from './views/contents/Player.vue';
import UserAccount from './views/contents/User.vue';

// ユーザ側
import UsersContents from './views/User.vue';

let routes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    {
        path: "/users/contents",
        hidden: true,
        component: UsersContents,
        name: '店舗管理（ユーザ側）',
        iconCls: 'fa fa-building-o'
    },
    {
        path: '/users',
        component: Home,
        name: 'コンテンツ種別管理',
        iconCls: 'fa fa-building-o',
        children: [
            { path: '/users/list', component: User, name: 'コンテンツ種別一覧' },
        ]
    },
    {
        path: '/contents',
        component: Home,
        name: 'コンテンツ管理',
        iconCls: 'fa fa-file-video-o',
        children: [
            { path: '/contents/list', component: Content, name: 'コンテンツ' },
            { path: '/contents/movies', component: Movie, name: '動画管理', general: true },
            { path: '/contents/images', component: Image, name: 'イメージ管理', general: true },
            { path: '/contents/categories', component: Category, name: 'カテゴリ管理' },
            { path: '/contents/series', component: Series, name: 'シリーズ管理' },
            { path: '/contents/users', component: UserAccount, name: 'ユーザ管理' },
            { path: '/contents/player', component: Player, name: 'プレイヤー設定' },
        ],
        general: true,
    },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js